const DOC_TYPES = [
  ".doc",
  ".dot",
  ".docx",
  ".docm",
  ".dotx",
  ".dotm",
  ".wpd",
  ".wps",
  ".sdw",
  ".sgl",
  ".vor",
  ".uot",
  ".uof",
  ".jtd",
  ".jtt",
  ".hwp",
  ".pdb",
  ".psw",
  ".rtf",
  ".htm",
  ".html",
];

const HTML_TYPE = [".htm", ".html"];

const XLS_TYPES = [
  ".xls",
  ".xlw",
  ".xlt",
  ".xls",
  ".xlw",
  ".xlt",
  ".xlsx",
  ".xlsm",
  ".xltx",
  ".xltm",
  ".xlsb",
  ".wk1",
  ".wks",
  ".123",
  ".sdc",
  ".vor",
  ".slk",
  ".uos",
  ".uof",
  ".pxl",
  ".wb2",
];

const PDF_TYPES = [".pdf"];

const PPTX_TYPES = [".pptx", ".pptm", ".ppt"];

const CSV_TYPES = [".csv", "dbf", "dif"];

const fileTypesToIcons = {
  HTML_TYPES: {
    types: HTML_TYPE,
    icon: "htmlIcon.svg",
  },
  DOC_TYPES: {
    types: DOC_TYPES,
    icon: "docIcon.svg",
  },
  XLS_TYPES: {
    types: XLS_TYPES,
    icon: "xlsIcon.svg",
  },
  CSV_TYPES: {
    types: CSV_TYPES,
    icon: "csvIcon.svg",
  },
  PDF_TYPES: {
    types: PDF_TYPES,
    icon: "pdfIcon.svg",
  },
  PPTX_TYPES: {
    types: PPTX_TYPES,
    icon: "pptxIcon.svg",
  },
};

function isVideo(asset) {
  return asset.embeddableVideo ? !!asset.embeddableVideo.videoId : false;
}

function getAssetExtenstion(asset) {
  const original = asset.original || {};
  const fileName = original.url || "";
  return (fileName.match(/\.[0-9a-z]+$/i) || [])[0];
}

export function getAssetIcon(asset) {
  let url;

  if (isVideo(asset)) {
    url = require("~/static/images/filetypes/videoIcon.svg");
    return url;
  }
  const fileType = getAssetExtenstion(asset);

  const fileTypeKeys = Object.keys(fileTypesToIcons);

  for (const key of fileTypeKeys) {
    const { types, icon } = fileTypesToIcons[key];
    if (types.includes(fileType)) {
      url = require(`~/static/images/filetypes/${icon}`);
      break;
    }
  }

  if (!url) {
    url = require("~/static/images/filetypes/blankIcon.svg");
  }

  return url;
}
